function isMobile() {
    return window.matchMedia( "( max-width: 1279px )" ).matches;
}

export default () => ({
    dropDownIsOpen: false, // TODO: naming; this name is dumb but is FPO while I rough out the rest of this
    hoverBufferInterval: 300, // in milliseconds
    hoverIntentCooldownTimer: null,

    navItemIsOpen() {
        // this is a placeholder in anticipation of multiple Desktop navbar dropdowns
        console.log( 'navItemIsOpen',{  'isMobile?': isMobile() } );
        if ( isMobile() ) {
            return false;
        }
        return this.dropDownIsOpen;
    },

    onMouseenterNavItem( event ) {
        if ( isMobile() ) { return; }
        let self = this;

        if ( !!self.hoverIntentCooldownTimer ) {
            clearTimeout( self.hoverIntentCooldownTimer );
            self.hoverIntentCooldownTimer = null;
        }
        self.dropDownIsOpen = true;
    },

    onMouseleaveNavItem( event ) {
        if ( isMobile() ) { return; }
        let self = this;
        self.hoverIntentCooldownTimer = setTimeout( ()=>{
            self.dropDownIsOpen = false;
            self.hoverIntentCooldownTimer = null;
        }, self.hoverBufferInterval );
    },

    onClickNavItem ( event ) {
        if ( isMobile() ) { return; }
        this.dropDownIsOpen = !this.dropDownIsOpen;
    },

    init() {
        let self = this;
        // console.log( "A Drop Down", { self, '$root': this.$root, 'mobile?': isMobile() } );
    }

})
